import {Base,Axios} from "@/api/Base"

export class ReportDownPaymentSlip extends Base {
    //此处修改后台登录用户修改密码的请求路径
    path = "report/downPaymentSlip"
    download(param = {}) {
        return Axios.get(this.path, { params: param,responseType: "blob" })
    }
}